<div class="fluidite-graph-inner" *transloco="let t; read: 'RESTAURANT_FLUIDITE_GRAPH_COMPONENT'">
  <ng-container *ngIf="isOpen && currentOccupation !== FluiditeTauxOccupationValues.Na && !graphIsEmpty">
    <div class="fluidite-taux-occupation flex justify-center">
      <span class="whitespace-pre">{{ t('CURRENTLY') }} : </span>
      <span
        [class.success-color]="currentOccupation === FluiditeTauxOccupationValues.Faible"
        [class.warning-color]="currentOccupation === FluiditeTauxOccupationValues.Moyen"
        [class.danger-color]="currentOccupation === FluiditeTauxOccupationValues.Eleve"
      >
        {{ 'FluiditeTauxOccupationValues.' + currentOccupation | transloco }}
      </span>
    </div>

    <div class="available-seats flex justify-center" *ngIf="fluiditeDetails.remainingSeats && !mini">
      <span class="whitespace-pre">{{ t('SEATS_AVAILABLE') }} : {{ fluiditeDetails.remainingSeats }}</span>
    </div>
  </ng-container>

  <div class="chart">
    <ng-container *ngIf="!graphIsEmpty; else noDataMsg">
      <div class="divider-container">
        <div class="divider"></div>
        <div class="divider"></div>
        <div class="divider"></div>
      </div>
      <div class="threshold-divider" *ngIf="!mini"></div>
      <div class="scale-divider"></div>
      <div class="column" *ngFor="let rate of fluiditeDetails.rates">
        <div class="bar-container">
          <div *ngIf="isNotNull(rate.currentWeekRate) && !isNotNull(rate.currentRate)" class="bar current-week" [style.height.%]="rate.currentWeekRate"></div>
          <div
            *ngIf="isNotNull(rate.currentRate)"
            class="bar current"
            [class.success-color]="currentOccupation === FluiditeTauxOccupationValues.Faible"
            [class.warning-color]="currentOccupation === FluiditeTauxOccupationValues.Moyen"
            [class.danger-color]="currentOccupation === FluiditeTauxOccupationValues.Eleve"
            [style.height.%]="rate.currentRate"
          ></div>
          <div
            *ngIf="isNotNull(rate.lastWeekRate) && (!isNotNull(rate.currentWeekRate) || isNotNull(rate.currentRate))"
            class="bar last-week"
            [class.lower-than-current]="rate.lastWeekRate! <= rate.currentRate! && currentOccupation !== FluiditeTauxOccupationValues.Na"
            [style.height.%]="rate.lastWeekRate"
          ></div>
        </div>

        <div class="scale">
          <ng-container *ngIf="rate.showStartLabel">
            <div class="tick"></div>
            <div class="label whitespace-pre">{{ rate.startsAt | translocoDate: { timeStyle: 'short' } }}</div>
          </ng-container>
          <ng-container *ngIf="rate.showEndLabel">
            <div class="tick"></div>
            <div class="label whitespace-pre">{{ rate.endsAt | translocoDate: { timeStyle: 'short' } }}</div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-template #noDataMsg>
      <app-error-container class="empty-graph-error" icon="stats-chart-outline" scope="FLUIDITE_GRAPH_COMPONENT" errorKey="DATA_NOT_AVAILABLE">
      </app-error-container>
    </ng-template>
  </div>
</div>
